import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { GenderListComponent } from './list/list.component';
import { AuthGuard } from '../auth/auth.guard';
import { GenderService } from './gender.service';
import { SharedModule } from '../shared/shared.module';
import { GenderCreateComponent } from './create/create.component';
import { GenderFormComponent } from './form/form.component';
import { GenderEditComponent } from './edit/edit.component';

const routes: Routes = [
  { path: 'genders', component: GenderListComponent, canActivate: [AuthGuard] },
  {
    path: 'genders/create',
    component: GenderCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'genders/:id/edit',
    component: GenderEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    GenderListComponent,
    GenderCreateComponent,
    GenderFormComponent,
    GenderEditComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, GenderService],
})
export class GenderRoutingModule {}
